<template>
    <range-input
        :range="null"
        :default="modelValue"
        :is-free="true"
        :decimals="0"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :unit="unit"
        absolute-min="0"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RangeInput from '@/components/RangeInput.vue';

export default defineComponent({
    components: {
        RangeInput,
    },

    props: {
        modelValue: {
            type: Number,
            required: true,
        },

        unit: {
            type: String,
            required: true,
        },
    },

    emits: {
        "update:modelValue": (payload: number) => typeof payload === "number",
    },

    setup()
    {
        return {};
    },
})
</script>
